module.exports = __webpack_public_path__ + "assets/9a4f92c1ad93c2f9008b9c041abc74f6.png";